import { useSync } from './useSync';
import { useAppNavigate } from './useAppNavigate';
import { SyncType } from '../types/sync/enums';

export const useFullSyncOnHome = () => {
    const { trigger } = useSync();
    const appNavigate = useAppNavigate();
    return (syncType = SyncType.Full) => {
        void trigger(syncType);
        appNavigate('/');
    };
};
